export const CANCEL_ORDER = "CANCEL_ORDER"
export const CANCEL_ORDER_SUCCESSFUL = "CANCEL_ORDER_SUCCESSFUL"
export const CANCEL_ORDER_FAILED = "CANCEL_ORDER_FAILED"